<template>
    <div id="app" class="container-fluid">
        <router-view></router-view>
    </div>
</template>
<script>
    import BootstrapVue from 'bootstrap-vue'
    import 'bootstrap-vue/dist/bootstrap-vue.css'
    Vue.use(BootstrapVue)
    import Vue from 'vue'
    import Vuetify from 'vuetify'
    Vue.use(Vuetify);
    import store from '../store';
    Vue.prototype.$store = store;

    export default{
        name: 'App',
        methods: {
            smoothScroll() {
                $('a[href*="#"]').on('click', function(e) {
                    e.preventDefault()

                    $('html, body').animate(
                        {
                            scrollTop: $($(this).attr('href')).offset().top,
                        },
                        500,
                        'linear'
                    )
                });
            },
        },
        mounted() {
            this.smoothScroll();

            if(window && window.FB) {
                window.FB.XFBML.parse();
            }
        }
    }
</script>

<style>
    #app{
        height: 100%;
        min-height: 100%;
        overflow-x: hidden;
        padding: 0px;
    }
</style>
